export enum ServerRoutes {
  acceptAdminInvite = '/accept-admin-invite',
  generateInvitationLink = '/generate-invitation-link',
  merchGPT = '/merch-gpt',
  merchGPTInstructionDraft = '/merch-gpt/instruction-draft',
  sendEmail = '/send-email',
  contact = '/contact',
  notificationsOrder = '/notifications/order',
  notifyQuoteRequest = '/notify-quote-request',
  purchaseIntent = '/purchase-intent',
  chatAction = '/chat-action',
  searchProducts = '/search-products',
  generateMockups = '/generate-mockups',
  getDecorationInfo = '/get-decoration-info',
  emailInboxSync = '/email-inbox/sync',
  emailInboxSend = '/email-inbox/send',
  emailInboxInsights = '/email-inbox/insights',
  emailInboxStatus = '/email-inbox/status',
}
